import { OrderConfirmationPage } from 'pages/order-confirmation/order-confirmation';

export default function OrderConfirmation() {
  return <OrderConfirmationPage />;
}
